import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService } from '@ciam/library';
import { TranslateService } from '@ngx-translate/core';

import { SessionStorageService } from '../../shared/services/sessionStorage-service/session-storage.service';

@Component({
  selector: 'wpro-banner-message',
  templateUrl: './banner-message.component.html',
  styleUrls: ['./banner-message.component.css'],
  standalone: false
})

export class BannerMessageComponent implements OnInit {
  description: string;
  link: any;
  toggleBannerMessage: boolean;
  mfaToggleStatus: boolean;
 bannerDecoupleFlag: boolean;
  isBannerClosed: boolean;
  isAppLoading: boolean;

  constructor(
    private router: Router,
    private scroller: ViewportScroller,
    private sessionStorageService: SessionStorageService,
    private translateService: TranslateService,
    private configService: ConfigurationService
  ) { }

  ngOnInit(): void {
    this.sessionStorageService.getItem$<boolean>('isAppLoading').subscribe(() => {
      this.checkBannerMessageStatus();
    });
    this.sessionStorageService.getItem$<boolean>('isBannerClosed').subscribe(() => {
      this.checkBannerMessageStatus();
    });
    this.sessionStorageService.getItem$<boolean>('mfaToggleStatus').subscribe(() => {
      this.checkBannerMessageStatus();
    });

    this.translateService.get('bannerMessage.description').subscribe((translations) => {
      const split = translations.split('{{splitIntoLink}}');
      this.description = split[0];
      this.link = split[1];
    });
  }

  /**
   *  Toggles Banner Message
   * */
  checkBannerMessageStatus(): void {
    this.bannerDecoupleFlag = this.configService.select<boolean>('bannerMessageDecoupleFlag') as boolean;
    this.mfaToggleStatus = this.sessionStorageService.getItem('mfaToggleStatus');
    this.isBannerClosed = this.sessionStorageService.getItem('isBannerClosed');
    this.isAppLoading = this.sessionStorageService.getItem('isAppLoading');

    this.toggleBannerMessage = (this.bannerDecoupleFlag || this.isBannerClosed ||
      this.mfaToggleStatus || this.isAppLoading);
  }

  closeBanner(): void {
    this.sessionStorageService.setItem('isBannerClosed', true);
  }

  /**
   * Scrolls/Navigate and Focus on 2FA Toggle Button
   * */
  navigate2faSection(): void {
    if (this.router.url === '/login') {
      const el = document.getElementById('check5.1');
      this.scroller.scrollToAnchor('2FA');
      setTimeout(() => {
        el.focus();
      }, 1000);
    } else {
      this.router.navigate(['/login']).then(() => {
        setTimeout(() => {
          const el = document.getElementById('check5.1');
          this.scroller.scrollToAnchor('2FA');
          setTimeout(() => {
            el.focus();
          }, 1000);
        }, 100);
      });
    }
  }
}
